export default "__VITE_ASSET__ba0f761e__"